import { render } from "./InputTransactionsButton.vue?vue&type=template&id=5b6ef433&scoped=true"
import script from "./InputTransactionsButton.vue?vue&type=script&lang=js"
export * from "./InputTransactionsButton.vue?vue&type=script&lang=js"

import "./InputTransactionsButton.vue?vue&type=style&index=0&id=5b6ef433&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tio-patinhas/tio-patinhas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6ef433"]])

export default __exports__